module.exports = __webpack_public_path__ + "static/media/au-bar.55c2767f.png";